export const LANG_KEY = 'langKey';
export const DEFAULT_LANG = 'en';
export const EN_LANG = 'en';
export const FR_LANG = 'fr';